import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

import type { LinkTarget } from '@/types'

import type { ButtonSize } from '../types'

export type ButtonOptions = {
    size?: ButtonSize
    width?: 'normal' | 'full'
    color?:
        | 'golden'
        | 'white'
        | 'white-08'
        | 'white-60'
        | 'white-20'
        | 'carbon-200'
        | 'carbon-300'
        | 'carbon-400'
        | 'carbon-purple-400'
        | 'purple-400'
        | 'purple-400-flat'
        | 'purple-500'
        | 'purple-600'
        | 'lime'
        | 'lavander-300'
        | 'rose-100'
        | 'rose-400'
        | 'purple-graphite'
        | 'salad'
    to?: RouteLocationRaw
    externalTo?: string
    target?: LinkTarget
    type?: 'button' | 'submit'
    disabled?: boolean
    interfaceTarget: string
    onClick?: (event: MouseEvent) => void
    onPointerdown?: (event: PointerEvent) => void
}

export function useButton(options: ButtonOptions) {
    const isLink = computed(() => !!(options.to ?? options.externalTo))

    const linkBindings = computed(() =>
        isLink.value
            ? {
                  to: options.to,
                  externalTo: options.externalTo,
                  target: options.target,
              }
            : {},
    )

    return {
        isLink,
        linkBindings,
    }
}
